


















































































import { Component, Vue } from 'vue-property-decorator';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerPermCurrentDetailsEdit from '@/components/Workers/WorkerPermCurrentDetailsEdit.vue';
import WorkerPermDesiredDetailsEdit from '@/components/Workers/WorkerPermDesiredDetailsEdit.vue';
import WorkerPermPreviousExperienceEdit from '@/components/Workers/WorkerPermPreviousExperienceEdit.vue';

import WorkType from '@/models/Shared/WorkType';

@Component({
  name: 'WorkerPermDetails',
  components: { WorkerPermCurrentDetailsEdit, WorkerPermPreviousExperienceEdit, WorkerPermDesiredDetailsEdit }
})
export default class extends GiganautVue {

	get isTemp() {
		return this.currentWorker.workTypes.includes(WorkType.Temp);
	}

	get isPerm() {
		return this.currentWorker.workTypes.includes(WorkType.Perm);
	}

	get currentWorker() {
		return WorkerDetailsModule.currentWorker;
	}
}
